import type { AccidentFeatureConfig } from '../../../types/insurances/AccidentFeatureConfig';

export const accident: AccidentFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showPackage: false,
            fallbackAssistancePhonesKey: 'HR',
            fallbackAssistanceEmailsKey: 'HR',
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
